import { render, staticRenderFns } from "./NewDashBoard.vue?vue&type=template&id=17804864&scoped=true"
import script from "./NewDashBoard.vue?vue&type=script&lang=js"
export * from "./NewDashBoard.vue?vue&type=script&lang=js"
import style0 from "./NewDashBoard.vue?vue&type=style&index=0&id=17804864&prod&lang=css"
import style1 from "./NewDashBoard.vue?vue&type=style&index=1&id=17804864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17804864",
  null
  
)

export default component.exports